{
  "signInRecovery": {
    "title": "Anmeldung unterbrochen",
    "processing": "Anmeldung wird abgeschlossen…",
    "message": "Die Anmeldung konnte nicht abgeschlossen werden. Melden Sie sich erneut an, um fortzufahren.",
    "action": "Erneut anmelden",
    "starting": "Anmeldung wird gestartet…",
    "restartFailed": "Die Anmeldung konnte nicht gestartet werden. Prüfen Sie, ob Ihr Browser das Speichern von Websitedaten erlaubt, und versuchen Sie es erneut."
  },
  "loading": "Laden...",
  "save": "Speichern",
  "cancel": "Abbrechen",
  "delete": "Löschen",
  "search": "Suchen",
  "close": "Schließen",
  "confirm": "Bestätigen",
  "yes": "Ja",
  "no": "Nein",
  "error": "Fehler",
  "success": "Erfolg",
  "retry": "Erneut versuchen",
  "upload": "Hochladen",
  "download": "Herunterladen",
  "logout": "Abmelden",
  "back": "Zurück",
  "redirectingToLogin": "Weiterleitung zur Anmeldung...",
  "profile": "Profil",
  "settings": "Einstellungen",
  "user": "Benutzer",
  "unnamedPerson": "Name nicht erfasst",
  "language": "Sprache",
  "selectLanguage": "Sprache auswählen",
  "appSwitcher": {
    "selectApp": "App auswählen",
    "title": "Anwendungen",
    "description": "Zwischen Agion-Anwendungen wechseln",
    "tooltip": "Anwendung wechseln",
    "admin": "Admin",
    "control": "Control",
    "app": "App",
    "analytics": "Analytics"
  },
  "adminDashboard": "Admin-Dashboard",
  "profileSettings": "Profil & Einstellungen",
  "uploadFiles": "Dateien hochladen",
  "uploadingFiles": "Dateien werden hochgeladen...",
  "pleaseWait": "Bitte warten",
  "dropFilesHere": "Dateien hier ablegen",
  "dropFilesOrClick": "Dateien ablegen oder klicken",
  "fileTypes": "Excel, CSV, JSON bis {{size}} MB",
  "status": {
    "active": "Aktiv",
    "busy": "Beschäftigt",
    "offline": "Offline",
    "pending": "Ausstehend",
    "uploading": "Wird hochgeladen",
    "processing": "Wird verarbeitet",
    "completed": "Abgeschlossen",
    "error": "Fehler",
    "uploaded": "Hochgeladen",
    "processed": "Verarbeitet"
  },
  "roles": {
    "owner": "Eigentümer",
    "admin": "Admin",
    "manager": "Manager",
    "user": "Benutzer",
    "auditor": "Prüfer"
  },
  "you": "Sie",
  "agent": "Agent",
  "manager": "Manager",
  "agents": {
    "system": {
      "assistant": "Agion Assistant"
    }
  },
  "hitl": {
    "expired": "Diese Anfrage ist abgelaufen.",
    "timeout": "Läuft ab in {{time}}",
    "placeholder": "Antwort eingeben...",
    "governanceRule": "Governance-Regel: {{rule}}",
    "operatorHandoff": {
      "title": "Agent benötigt Betreiberhilfe",
      "description": "Der Agent kann dies nicht lösen und bittet um menschliche Unterstützung"
    },
    "policyReview": {
      "title": "Governance-Prüfung erforderlich",
      "description": "Eine Governance-Richtlinie erfordert eine menschliche Überprüfung vor dem Fortfahren",
      "approve": "Genehmigen",
      "deny": "Ablehnen",
      "decideElsewhere": "Über diese Genehmigung wird unter Eskalationen entschieden.",
      "openEscalations": "Unter Eskalationen entscheiden"
    }
  },
  "nextShell": {
    "sidebar": "Chat-Navigation",
    "missionsNavigation": "Missionen",
    "expandSidebar": "Seitenleiste ausklappen",
    "collapseSidebar": "Seitenleiste einklappen",
    "openNavigation": "Navigation öffnen",
    "closeNavigation": "Navigation schließen",
    "organization": "Organisation",
    "files": "Dateien",
    "running": "Läuft",
    "theme": {
      "currentLight": "Heller Modus",
      "currentDark": "Dunkler Modus",
      "switchToLight": "Zum hellen Modus wechseln",
      "switchToDark": "Zum dunklen Modus wechseln"
    },
    "appSwitcher": {
      "chat": "Chat",
      "switchApp": "App wechseln",
      "currentApp": "Aktuelle App",
      "open": "Öffnen"
    },
    "missionsLoadError": "Missionen konnten nicht geladen werden"
  },
  "nextFailure": {
    "hostUnknown": "Der Edge-Host, der diese Mission ausgeführt hat, ist nicht erfasst, daher kann ihre Unterhaltung nicht gefunden werden.",
    "network": "Die Verbindung zu Agion ist fehlgeschlagen. Prüfen Sie Ihr Netzwerk und versuchen Sie es erneut.",
    "unavailable": "Der Dienst antwortet gerade nicht. Versuchen Sie es gleich noch einmal.",
    "session": "Ihre Sitzung ist abgelaufen. Melden Sie sich erneut an, um fortzufahren.",
    "forbidden": "Ihre Rolle erlaubt dies nicht.",
    "missing": "Es existiert nicht mehr oder wurde verschoben.",
    "refused": "Die Anfrage wurde abgelehnt.",
    "unknown": "Etwas ist schiefgelaufen. Versuchen Sie es erneut.",
    "hostOfflineNamed": "{{name}}, der Edge-Host mit dieser Unterhaltung, ist offline. Versuchen Sie es erneut, wenn er wieder erreichbar ist.",
    "hostOffline": "Der Edge-Host mit dieser Unterhaltung ist offline. Versuchen Sie es erneut, wenn er wieder erreichbar ist."
  }
}
